export interface AppConfig {
  storyRegionDomain: string;
}

let cachedConfig: Promise<AppConfig> | null = null;

// fetched once per page load and cached, since it comes from this region's own Static Web App settings
export const getConfig = (): Promise<AppConfig> => {
  if (!cachedConfig) {
    cachedConfig = fetch("/api/GetConfig").then((res) => res.json());
  }
  return cachedConfig;
};
